import type {AppConfig} from './appConfig.types';
import {getConfig} from './config';

const getPushNotificationsSettings = () => (getConfig() as AppConfig).pushNotificationsSettings;

const getMaxPossiblePromptCount = () => getPushNotificationsSettings().maxPossiblePromptCount;
const getMinimumAfterPreviousPromptDays = () => getPushNotificationsSettings().minimumAfterPreviousPromptDays;
const getShowPromptAfterAutodeliveryDashboardClickDays = () =>
    getPushNotificationsSettings().showPromptAfterAutodeliveryDashboardClickDays;
const getShowPromptAfterLoyaltyClickDays = () => getPushNotificationsSettings().showPromptAfterLoyaltyClickDays;
const getShowPromptAfterUrlClickOnShopPageDays = () =>
    getPushNotificationsSettings().showPromptAfterUrlClickOnShopPageDays;
const getShowPromptIfLoggedInDays = () => getPushNotificationsSettings().showPromptIfLoggedInDays;

export default {
    getMaxPossiblePromptCount,
    getMinimumAfterPreviousPromptDays,
    getShowPromptAfterAutodeliveryDashboardClickDays,
    getShowPromptAfterLoyaltyClickDays,
    getShowPromptAfterUrlClickOnShopPageDays,
    getShowPromptIfLoggedInDays,
};
